import { ENTERPRISE_PAGE_MAP } from "@/constants/enterprisePageMap";
import { globalConstants, routesWithoutHeaderFooterConfig } from '@/constants/globalConstants';
export const toTitleCase = (
  str = "",
  smallWords = [],
  replacements = {},
  enableSmartCase = true,
) => {
  if (!str) return "";

  return str
    .toLowerCase()
    .split(" ")
    .map((word, index) => {
      const originalWord = word;

      // Smart case: keep small words lowercase except first
      if (enableSmartCase) {
        const isSmallWord = smallWords.includes(word);
        if (isSmallWord && index !== 0) {
          return replacements[originalWord] || originalWord;
        }
      }

      // Normal Title Case
      let formatted =
        word.charAt(0).toUpperCase() + word.slice(1);

      // Apply replacement if exists
      if (replacements[originalWord]) {
        return replacements[originalWord];
      }

      return formatted;
    })
    .join(" ");
};


export const getLinkDetails = (link, section = "") => {
  const generic = globalConstants.generic;
  const dataLinkPrefix = section ? generic.CTA[section] : '';
  const title = link?.external_link?.title;
  const lower = title?.toLowerCase();
  const linkTitle = link?.isexternal
    ? (!['faqs', 'join eclub'].includes(lower)
      ? title?.toLowerCase()
      : title
    )
    : link?.page_title?.toLowerCase() || "";
  const linkUrl = link?.isexternal
    ? link?.external_link?.href
    : link?.internal_page?.[0]?.url || "#";

  const linkTarget = link?.target || "_self";
  const ariaLabel = link?.aria_label || undefined;
  const aria_describedby = link?.aria_describedby || undefined;
  const role = link?.role || undefined;
  let dataLinkInfo = link?.data_link_info ? link?.data_link_info : dataLinkPrefix + linkTitle;
  dataLinkInfo = dataLinkInfo.includes('cta') ? dataLinkInfo : dataLinkInfo + `${' ' + generic.CTA.postText}`;
  const linkID = link?.link_id || undefined;
  const onClick = link?.onclick || undefined;
  const className = link?.class || "";
  return {
    linkTitle,
    linkUrl,
    linkTarget,
    ariaLabel,
    aria_describedby,
    role,
    dataLinkInfo,
    linkID,
    onClick,
    className,
  };
};

export const getParseTextByPipe = (rawText) => {
  if (!rawText && rawText.trim().length === 0) return [];
  // const rawText = "Item 1 | Item 2 \\| with pipe | Item 3";
  const placeholder = "__PIPE__";
  // Step 1: Replace escaped pipe with placeholder
  const temp = rawText.replace(/\\\|/g, placeholder);
  // Step 2: Split by delimiter pipe
  const parts = temp.split("|");
  // Step 3: Restore actual pipe
  const finalParts = parts.map((part) =>
    part.replace(new RegExp(placeholder, "g"), "|")
  );

  return finalParts || [];
};

export const isWithinInterval = (storedTimestamp, cacheTime) => {
  const currentTimestamp = Date.now();
  const diffInMs = currentTimestamp - storedTimestamp;
  return diffInMs <= cacheTime * 1000;
};


export const isEnterprisePage = (brand, pathname) => {
  return (
    ENTERPRISE_PAGE_MAP[brand]?.pages?.includes(pathname)
  )
}

export const getHeadingDetails = (heading) => {
  const text = heading?.text || undefined;
  const fontFamily = heading?.font_family || undefined;
  const fontSize = heading?.font_size || undefined;
  const textAlign = heading?.horizontal_position || undefined;
  return {
    text,
    fontFamily,
    fontSize,
    textAlign
  };
}


export const getLinkDetailsEnterprise = (link, section = "") => {
  const generic = globalConstants.generic;
  const dataLinkPrefix = section ? generic.CTA[section] : '';
  const linkTitle = link?.isexternal
    ? link?.external_link?.title
    : link?.page_title || "";
  const linkUrl = link?.isexternal
    ? link?.external_link?.href
    : link?.internal_page?.[0]?.url || "#";

  const linkTarget = link?.target || "_self";
  const ariaLabel = link?.aria_label || undefined;
  const aria_describedby = link?.aria_describedby || undefined;
  const role = link?.role || undefined;
  let dataLinkInfo = link?.data_link_info ? link?.data_link_info : dataLinkPrefix + linkTitle;
  dataLinkInfo = dataLinkInfo.includes('cta') ? dataLinkInfo : dataLinkInfo + `${' ' + generic.CTA.postText}`;
  const linkID = link?.link_id || undefined;
  const onClick = link?.onclick || undefined;
  return {
    linkTitle,
    linkUrl,
    linkTarget,
    ariaLabel,
    aria_describedby,
    role,
    dataLinkInfo,
    linkID,
    onClick,
  };
};

export const getEnterpriseLinkDetails = (link, section = "", isHoverBorder) => {
  const generic = globalConstants?.generic;
  const dataLinkPrefix = section ? generic.CTA[section] : '';
  const linkTitle = link?.isexternal
    ? link?.heading?.text
    : link?.heading?.text || ''; //TODO: CHANGE AS PER ISEXTERNAL = FALSE
  const linkUrl = link?.isexternal
    ? link?.url
    : link?.url || "#"; //TODO: CHANGE AS PER ISEXTERNAL = FALSE

  const linkTarget = link?.target || "_self";
  const fontFamily = link?.heading?.font_family || undefined;
  const fontSize = link?.heading?.font_size || undefined;
  const textAlign = link?.heading?.horizontal_position || undefined;
  let dataLinkInfo = link?.link_info?.data_link_info ? link?.link_info?.data_link_info : dataLinkPrefix + linkTitle;
  dataLinkInfo = dataLinkInfo.includes('cta') ? dataLinkInfo : dataLinkInfo + `${' ' + generic.CTA.postText}`;
  const linkID = link?.link_info?.link_id || undefined;
  const { desktop, mobile } = getButtonPropsFromEnterpriseLink(link, isHoverBorder);
  return {
    linkTitle,
    linkUrl,
    linkTarget,
    dataLinkInfo,
    linkID,
    fontFamily,
    fontSize,
    textAlign,
    desktop,
    mobile
  };
};

/**
 * Converts CMS color object to CSS color string.
 * - If alpha exists and < 1, returns rgba()
 * - Else returns hex
 */
export function cmsColorToCss(color) {
  if (!color) return undefined;

  const a = color?.rgb?.a;
  const r = color?.rgb?.r;
  const g = color?.rgb?.g;
  const b = color?.rgb?.b;

  // If alpha present and < 1 => rgba
  if (typeof a === "number" && a >= 0 && a < 1 && [r, g, b].every(v => typeof v === "number")) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  // Otherwise use hex when available
  if (typeof color?.hex === "string") return color.hex;

  // Fallback to rgb if hex missing
  if ([r, g, b].every(v => typeof v === "number")) {
    return `rgb(${r}, ${g}, ${b})`;
  }

  return undefined;
}

/**
 * Utility for fallbacks: prefers first non-null/undefined.
 */
const pick = (...values) => values.find(v => v !== null && v !== undefined);


function makeBorder(entry, color, isHoverBorder) {
  const borderWidth = entry?.border_width;
  const borderColor = cmsColorToCss(color);
  if (!isHoverBorder || !borderWidth) return 0;
  return `${borderWidth}px solid ${borderColor}`;
}


/**
 * Normalize your enterprise_link object to a single button config object.
 */
export function getButtonPropsFromEnterpriseLink(entry, isHoverBorder = true) {
  if (!entry) return null;

  const heading = entry.heading || {};
  const border = makeBorder(entry, entry?.border_color, true);
  const hoverBorder = makeBorder(entry, entry?.hover_border_color, isHoverBorder);

  const desktop = {
    fontFamily: pick(heading?.font_family, "inherit"),
    fontSize: pick(heading?.font_size, 16),          // number ok, component can add px
    fontWeight: pick(heading?.font_weight, 700),
    textAlign: pick(heading?.horizontal_position, "center"),
    marginTop: pick(heading?.desktop_margin?.top, 0),
    marginBottom: pick(heading?.desktop_margin?.bottom, 0),
    marginLeft: pick(heading?.desktop_margin?.left, 0),
    marginRight: pick(heading?.desktop_margin?.right, 0),

    bgColor: cmsColorToCss(entry.background_color),
    textColor: cmsColorToCss(entry.text_color),
    hoverBgColor: cmsColorToCss(entry.hover_background_color),
    hoverTextColor: cmsColorToCss(entry.text_hover_color),
    border,
    hoverBorder
  };

  const mobile = {
    fontFamily: pick(heading?.mobile_font_family, desktop.fontFamily),
    fontSize: pick(heading?.mobile_font_size, desktop.fontSize),
    fontWeight: pick(heading?.mobile_font_weight, desktop.fontWeight),
    textAlign: pick(heading?.mobile_horizontal_position, desktop.textAlign),
    marginTop: pick(heading?.mobile_margin?.top, 0),
    marginBottom: pick(heading?.mobile_margin?.bottom, 0),
    marginLeft: pick(heading?.mobile_margin?.left, 0),
    marginRight: pick(heading?.mobile_margin?.right, 0),

    bgColor: desktop.bgColor,
    textColor: desktop.textColor,
    hoverBgColor: desktop.hoverBgColor,
    hoverTextColor: desktop.hoverTextColor,
    border,
    hoverBorder
  };

  return {
    desktop,
    mobile
  };
}


export default function getExtractedPositionsCSS(config) {
  const vars = {};

  const hasNum = (v) => typeof v === "number" && !Number.isNaN(v) && Number.isFinite(v);
  const hasStr = (v) => typeof v === "string" && v.trim().length > 0;

  const toUnit = (value, unit) => `${value}${unit}`;

  // Desktop size
  if (config && hasNum(config.desktop_height) && hasStr(config.desktop_height_unit)) {
    vars["--desktop-height"] = toUnit(config.desktop_height, config.desktop_height_unit);
  }
  if (config && hasNum(config.desktop_width) && hasStr(config.desktop_width_unit)) {
    vars["--desktop-width"] = toUnit(config.desktop_width, config.desktop_width_unit);
  }

  // Desktop positions
  if (config && hasStr(config.desktop_vertical_position)) {
    vars["--desktop-vertical-position"] = config.desktop_vertical_position.toLowerCase();
  }
  if (config && hasStr(config.desktop_horizontal_position)) {
    vars["--desktop-horizontal-position"] = config.desktop_horizontal_position.toLowerCase();
  }

  // Desktop padding (only if provided & not null)
  const dp = config?.desktop_padding;
  if (dp && hasNum(dp.top)) vars["--desktop-padding-top"] = `${dp.top}px`;
  if (dp && hasNum(dp.right)) vars["--desktop-padding-right"] = `${dp.right}px`;
  if (dp && hasNum(dp.bottom)) vars["--desktop-padding-bottom"] = `${dp.bottom}px`;
  if (dp && hasNum(dp.left)) vars["--desktop-padding-left"] = `${dp.left}px`;

  // Mobile size
  if (config && hasNum(config.mobile_height) && hasStr(config.mobile_height_unit)) {
    vars["--mobile-height"] = toUnit(config.mobile_height, config.mobile_height_unit);
  }
  if (config && hasNum(config.mobile_width) && hasStr(config.mobile_width_unit)) {
    vars["--mobile-width"] = toUnit(config.mobile_width, config.mobile_width_unit);
  }

  // Mobile positions
  if (config && hasStr(config.mobile_vertical_position)) {
    vars["--mobile-vertical-position"] = config.mobile_vertical_position.toLowerCase();
  }
  if (config && hasStr(config.mobile_horizontal_position)) {
    vars["--mobile-horizontal-position"] = config.mobile_horizontal_position.toLowerCase();
  }

  // Mobile padding
  const mp = config?.mobile_padding;
  if (mp && hasNum(mp.top)) vars["--mobile-padding-top"] = `${mp.top}px`;
  if (mp && hasNum(mp.right)) vars["--mobile-padding-right"] = `${mp.right}px`;
  if (mp && hasNum(mp.bottom)) vars["--mobile-padding-bottom"] = `${mp.bottom}px`;
  if (mp && hasNum(mp.left)) vars["--mobile-padding-left"] = `${mp.left}px`;

  return vars;

}


export function buildCardStyleFromRawPayload(raw = {}) {
  const {
    desktop_height,
    desktop_height_unit,
    desktop_width,
    desktop_width_unit,
    desktop_horizontal_position,
    desktop_vertical_position,
    desktop_padding,

    mobile_height,
    mobile_height_unit,
    mobile_width,
    mobile_width_unit,
    mobile_horizontal_position,
    mobile_vertical_position,
    mobile_padding
  } = raw;

  // Convert human positions to flexbox
  const toFlex = (value, axis = "horizontal") => {
    if (!value) return "center";
    const v = value.toString().toLowerCase();
    if (v === "center") return "center";

    if (axis === "horizontal") {
      if (v === "left") return "flex-start";
      if (v === "right") return "flex-end";
    }
    if (axis === "vertical") {
      if (v === "top") return "flex-start";
      if (v === "bottom") return "flex-end";
    }
    return "center";
  };

  // Text-align always maps from horizontal
  const inferTextAlign = (horizontal) => {
    if (!horizontal) return "center";
    const v = horizontal.toString().toLowerCase();
    if (v === "left") return "left";
    if (v === "right") return "right";
    return "center";
  };

  const mapPadding = (prefix, pad) => {
    if (!pad) return {};
    const output = {};

    if (pad.top != null)
      output[`--${prefix}-padding-top`] = `${pad.top}px`;

    if (pad.right != null)
      output[`--${prefix}-padding-right`] = `${pad.right}px`;

    if (pad.bottom != null)
      output[`--${prefix}-padding-bottom`] = `${pad.bottom}px`;

    if (pad.left != null)
      output[`--${prefix}-padding-left`] = `${pad.left}px`;

    return output;
  };

  const style = {
    // SIZE
    "--desktop-height": desktop_height ? `${desktop_height}${desktop_height_unit}` : undefined,
    "--desktop-width": desktop_width ? `${desktop_width}${desktop_width_unit}` : undefined,

    "--mobile-height": mobile_height ? `${mobile_height}${mobile_height_unit}` : undefined,
    "--mobile-width": mobile_width ? `${mobile_width}${mobile_width_unit}` : undefined,

    // DESKTOP ALIGNMENT
    "--desktop-horizontal": toFlex(desktop_horizontal_position, "horizontal"),
    "--desktop-vertical": toFlex(desktop_vertical_position, "vertical"),
    "--desktop-content-text-align": inferTextAlign(desktop_horizontal_position),

    // MOBILE ALIGNMENT
    "--mobile-horizontal": toFlex(mobile_horizontal_position, "horizontal"),
    "--mobile-vertical": toFlex(mobile_vertical_position, "vertical"),
    "--mobile-content-text-align": inferTextAlign(mobile_horizontal_position),

    // PADDING (mapped)
    ...mapPadding("desktop", desktop_padding),
    ...mapPadding("mobile", mobile_padding)
  };

  // Clean undefined values
  Object.keys(style).forEach(key => style[key] === undefined && delete style[key]);

  return style;
}


export function getMetaData({
  baseUrl = "",
  path = "",
  title = "",
  description = "",
  ogTitle = "",
  ogImage = "",
  siteName = "",
} = {}) {
  const canonicalUrl = `${baseUrl}${path}`;

  return {
    title,
    description,

    other: {
      keywords: "",
      robots: "index,follow",
      "robots-2": "noodp,noydir",
    },

    robots: {
      index: true,
      follow: true,
    },

    // Open Graph
    openGraph: {
      title: ogTitle,
      description,
      url: canonicalUrl,
      siteName: siteName,
      type: "website",
      images: [
        {
          url: ogImage,
          alt: siteName,
        },
      ],
    },

    alternates: {
      canonical: canonicalUrl,
      media: {
        "only screen and (max-width: 640px)": canonicalUrl,
      },
    },

    // Favicons
    icons: {
      icon: "https://media.ruthschris.com/images/site/favicon.ico",
      shortcut: "https://media.ruthschris.com/images/site/favicon.ico",
    },

    // Viewport meta
    viewport: {
      width: "device-width",
      initialScale: 1,
    },
  };
}


export function formatPhoneUS(phone) {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
}

export function formatZip(zip) {
  if (!zip) return "";
  const digits = String(zip).replace(/\D/g, "");
  if (digits.length === 9) return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  return digits;
}

 const DAY_ORDER = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export function buildDaysLabel(days) {
  if (!days || days.length === 0) return "";

  const idxs = days
    .map((d) => DAY_ORDER.indexOf(d))
    .filter((i) => i >= 0)
    .sort((a, b) => a - b);

  if (idxs.length === 0) return "";

  // Group consecutive ranges
  const ranges = [];
  let start = idxs[0];
  let prev = idxs[0];

  for (let i = 1; i < idxs.length; i++) {
    if (idxs[i] === prev + 1) {
      prev = idxs[i];
    } else {
      ranges.push([start, prev]);
      start = idxs[i];
      prev = idxs[i];
    }
  }
  ranges.push([start, prev]);

  const parts = ranges.map(([s, e]) =>
    s === e ? DAY_ORDER[s] : `${DAY_ORDER[s]} - ${DAY_ORDER[e]}`,
  );

  if (parts.length === 1) return parts[0];
  if (parts.length === 2) return `${parts[0]} & ${parts[1]}`;
  return `${parts.slice(0, -1).join(", ")} & ${parts[parts.length - 1]}`;
}

export function getHappyHourInfo(restaurantHours = []) {
  const hhDays = [];
  let startTime = "";
  let endTime = "";

  for (const dayObj of restaurantHours) {
    const hh = dayObj?.hoursInfo?.find(
      (h) => h?.hourCode === "HH" || h?.name === "Happy Hour",
    );
    if (hh) {
      hhDays.push(dayObj.day);

      // take first encountered HH as canonical time
      if (!startTime) startTime = hh.startTime || "";
      if (!endTime) endTime = hh.endTime || "";
    }
  }

  // sort in week order
  hhDays.sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));

  // match your UI style "4:00PM-6:00PM"
  const timeLabel =
    startTime && endTime
      ? `${startTime.replace(" ", "")}-${endTime.replace(" ", "")}`
      : "";

  return {
    hhDays,
    daysLabel: buildDaysLabel(hhDays),
    timeLabel,
  };
}

export const matchesExcludedRoute = (pathname) => {
  if (!pathname) return false;
  return routesWithoutHeaderFooterConfig.some((route) =>
    pathname.includes(route),
  );
};